import axios from './http'
import base from './base'

/**
 * 登陆
 */
export function userLogin(params={}){
  return new Promise((resolve,reject) => {
    axios.post(`${base.url}/user/login`,{
        user:params.user,
        pass:params.pass
    })
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}
/**
 * 获取地区归属列表
 */
export function getBelong(params={}){
  return new Promise((resolve,reject) => {
    axios.get(`${base.url}/car/getBelong`,{
        params:params
    })
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}
/**
 * 获取该账户下车辆的geojson
 */
export function getCarJson(params={}){
  return new Promise((resolve,reject) => {
    axios.get(`${base.url}/car/getCarJson`)
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}
/**
 * 后台获取所以车辆信息
 */
export function getCars(params={}){
  return new Promise((resolve,reject) => {
    axios.get(`${base.url}/car/getCars?val=`+params.val+'&code='+params.code+'&page='+params.page+'&limit='+params.limit)
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 后台删除车辆信息
 */
export function deleteCar(params={}){
  return new Promise((resolve,reject) => {
    axios.get(`${base.url}/car/deleteCar?sn=`+params.sn)
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}
/**
 * 姓名、机器码搜索车辆
 */
export function queryCar(params={}){
  return new Promise((resolve,reject) => {
    axios.get(`${base.url}/car/queryCar`,{
      params:params
    })
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 后台获取所有用户信息
 */
export function getAllUser(params={}){
  return new Promise((resolve,reject) => {
    axios.get(`${base.url}/user/getAllUser?page=`+params.page+'&limit='+params.limit+'&usertype='+params.usertype+'&val='+params.val+'&code='+params.code)
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}
/**
 * 后台删除指定用户信息
 */
export function deleteUser(params={}){
  return new Promise((resolve,reject) => {
    axios.post(`${base.url}/user/deleteUser`,{
		id:params
	})
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 个人中心:本人信息
 */
export function getUserInfo(){
  return new Promise((resolve,reject) => {
    axios.get(`${base.url}/user/getInfo`)
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 个人中心:修改本人密码
 */
export function changeOwnPass(params={}){
  return new Promise((resolve,reject) => {
    axios.post(`${base.url}/user/changeOwnPass`,{
        oldpass:params.oldpass,
        newpass:params.newpass
    })
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 后台获取所有桩机型号
 */
export function getCarModel(params={}){
  let val = params.val?params.val:''
  return new Promise((resolve,reject) => {
    axios.get(`${base.url}/car/getCarModel?val=`+val+'&page='+params.page+'&limit='+params.limit)
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 根据地区归属下拉车辆
 */
// export function getCarByBelong(params={}){
//   return new Promise((resolve,reject) => {
//     axios.get(`${base.url}/car/getCarByBeLong?belongId=`+params.belongId)
//     .then(response => {
//       resolve(response);
//     })
//     .catch(err => {
//       reject(err)
//     })
//   })
// }
/**
 * 根据地区归属获取第三级老板
 */
export function getUserAccount(params={}){
  return new Promise((resolve,reject) => {
    axios.get(`${base.url}/car/getUserAccount?belongId=`+params.belongId)
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}
/**
 * 根据地区归属获取第三级老板
 */
export function getUserCarList(params={}){
  return new Promise((resolve,reject) => {
    axios.get(`${base.url}/car/getUserCarList?id=`+params.id)
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}
/**
 * 根据SN获取桩机信息(地图)
 */
export function getCarBySn(params={}){
  return new Promise((resolve,reject) => {
    axios.get(`${base.url}/car/getCarBySn?sn=`+params.sn)
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 根据SN获取当天作业信息
 */
export function getTodayWorkBySn(params={}){
  return new Promise((resolve,reject) => {
    axios.get(`${base.url}/car/getTodayWorkBySn?sn=`+params.sn)
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 作业分析
 */
export function workAnalysis(params={}){
  return new Promise((resolve,reject) => {
    axios.get(`${base.url}/car/workAnalysis?sn=`+params.sn+'&StartTime='+params.StartTime+'&EndTime='+params.EndTime+'&Error='+params.Error)
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 作业对比分析
 */
export function workContrast(params={}){
  return new Promise((resolve,reject) => {
    axios.post(`${base.url}/car/workContrast`,{
      sn:params.sn,
      StartTime:params.StartTime,
      EndTime:params.EndTime,
      Error:params.Error
    })
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 作业统计列表
 */
export function workStatisticsList(params={}){
  return new Promise((resolve,reject) => {
    axios.get(`${base.url}/car/workStatisticsList?sn=`+params.sn+'&start='+params.StartTime+'&end='+params.EndTime+'&error='+params.Error+'&page='+params.page+'&limit='+params.limit)
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 作业统计列表导出
 */
export function exportWorkStatistics(params={}){
  return new Promise((resolve,reject) => {
    axios.get(`${base.url}/car/exportWorkStatistics?sn=`+params.sn+'&start='+params.StartTime+'&end='+params.EndTime+'&error='+params.Error)
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 添加用户
 */
export function addUser(params={}){
  return new Promise((resolve,reject) => {
    axios.post(`${base.url}/user/addUser`,{
      username:params.username,
      password:params.password,
      personName:params.personName,
      phone:params.phone,
      belongId:params.belongId,
      usertype:params.usertype,
      agentId:params.agentId
    })
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 修改用户
 */
export function updateUser(params={}){
  return new Promise((resolve,reject) => {
    axios.post(`${base.url}/user/updateUser`,{
      id:params.id,
      username:params.username,
      personName:params.personName,
      phone:params.phone,
      belongId:params.belongId,
      usertype:params.usertype,
      agentId:params.agentId
    })
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 重置密码
 */
export function resetPass(params={}){
  return new Promise((resolve,reject) => {
    axios.post(`${base.url}/user/resetPass`,{
      id:params.id,
      password:params.password
    })
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 用户搜索
 */
export function getSelectAllUser(params={}){
  return new Promise((resolve,reject) => {
    axios.post(`${base.url}/user/getSelectAllUser?code=`+params.code+'&val='+params.val+'&page='+params.page+'&limit='+params.limit)
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 添加桩机型号
 */
export function addModel(params={}){
  return new Promise((resolve,reject) => {
    axios.post(`${base.url}/car/addModel`,{
      carModel:params.carModel,
      agentId:params.agentId,
    })
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 删除桩机型号
 */
export function deleteModel(params={}){
  return new Promise((resolve,reject) => {
    axios.post(`${base.url}/car/deleteModel`,{
      id:params.id
    })
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 更新桩机型号
 */
export function updateModel(params={}){
  return new Promise((resolve,reject) => {
    axios.post(`${base.url}/car/updateModel`,{
      id:params.id,
      carModel:params.carModel
    })
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取桩机型号(无分页)
 */
export function getCarModelList(params={}){
  return new Promise((resolve,reject) => {
    axios.get(`${base.url}/car/getCarModelList`)
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}


/**
 * 后台添加桩机
 */
export function addCar(params={}){
  return new Promise((resolve,reject) => {
    axios.post(`${base.url}/car/addCar`,{
      SN:params.SN,
      SN1:params.SN1,
      CarBelongCode:params.CarBelongCode,
      CarModel:params.CarModel,
      CarName:params.CarName,
      CarPhone:params.CarPhone,
      Sim:params.Sim,
      Remark:params.Remark,
      AgentId:params.AgentId,
    })
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 注册
 */
export function regCode(params={}){
  return new Promise((resolve,reject) => {
    axios.post(`${base.url}/car/regCode`,{
      sn:params.sn,
      day:params.day
    })
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 编辑桩机
 */
export function updateCar(params={}){
  return new Promise((resolve,reject) => {
    axios.post(`${base.url}/car/updateCar`,{
      oldsn:params.oldsn,
      id:params.carId,
      SN1:params.SN1,
      SN:params.SN,
      carName:params.carName,
      carPhone:params.carPhone,
      carModel:params.carModel,
      CarBelongCode:params.CarBelongCode,
      Sim:params.Sim,
      Remark:params.Remark,
      AgentId:params.AgentId,
    })
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 用户下拉地区列表所有
 * belongList
 */
export function belongList(params={}){
  return new Promise((resolve,reject) => {
    axios.get(`${base.url}/car/belongList`)
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}

/**
 * 上传作业
 */
// export function uploadPoint(params={}){
//   // console.log(params)
//   return new Promise((resolve,reject) => {
//     axios.post(`${base.url}/car/uploadPoint`,{
//       params
//     })
//     .then(response => {
//       resolve(response);
//     })
//     .catch(err => {
//       reject(err)
//     })
//   })
// }

/**
 * 测试
 */
// export function getCarBySn(params={}){
//   return new Promise((resolve,reject) => {
//     axios.get(`${base.url}/car/getCarBySn?sn=`+params.sn)
//     .then(response => {
//       resolve(response);
//     })
//     .catch(err => {
//       reject(err)
//     })
//   })
// }
/**
 * post方法，对应post请求
 * @desc注册请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
// export function userRejister(data) {
//     return axios({
//         url: `${base.url}/users/register`,
//         method: 'post',
//         data: QS.stringify(data)
//     })
// }
/**
 * get方法，对应get请求
 * @desc登录请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
// export function userInfo() {
//     return axios({
//         url: `${base.url}/profile/all`,
//         method: 'get'
//     })
// }



// WEBPACK FOOTER //
// ./src/utils/api.js